export default "__VITE_ASSET__914b664d__"